<template>
    <div style="padding: 1px;">
        <az-container class="relatorioTceContainer">
            <v-form class="az-form-content mt-0 pl-0 pr-0 ">
                <v-container fluid grid-list-xl white class="formRelatoriosTce">
                    <v-row wrap align-center white class="pl-10 pr-10">
                        <v-col cols="12" md="4" sm="4">
                            <az-combo-enum
                                ref="selectTipoRelatorio"
                                name="relatorio"
                                label="Relatório"
                                placeholder="Selecione"
                                :enumObject="comboRelatorios"
                                class="campoEnumRelatoriosTce"
                                v-model="relatorio.tipoRelatorio"
                            />
                        </v-col>

                        <v-col v-if="isRelatorioDemonstrativoOuResumo" cols="12" md="4" sm="4" >
                            <az-date
                                date
                                :isRequired="true"
                                nameDate="dataInicio"
                                class="campoDataInicio"
                                v-validate="'required'"
                                v-model="relatorio.dataInicio"
                                :placeholderDate="'__/__/____'"
                                :error-messages="errors.collect('dataInicio')"
                                :maxDate="moment(new Date()).format('YYYY-MM-DDTHH:mm:ssZZ')"
                                @input="limparDataFim"
                            >
                                <template v-slot:label-date>
                                    <div>
                                        Data Inicial <span class="ml-1 red--text">*</span>
                                    </div>
                                </template>
                            </az-date>
                        </v-col>

                        <v-col v-if="isRelatorioDemonstrativoOuResumo" cols="12" md="4" sm="4" >
                            <az-date
                                date
                                :isRequired="true"
                                nameDate="dataFim"
                                class="campoDataFim"
                                v-validate="'required'"
                                v-model="relatorio.dataFim"
                                :placeholderDate="'__/__/____'"
                                :error-messages="errors.collect('dataFim')"
                                :maxDate="moment(new Date()).format('YYYY-MM-DDTHH:mm:ssZZ')"
                                @input="limparDataFim"
                            >
                                <template v-slot:label-date>
                                    <div>
                                        Data Final <span class="ml-1 red--text">*</span>
                                    </div>
                                </template>
                            </az-date>
                        </v-col>

                        <v-col v-if="isRelatorioInventario" cols="12" md="4" sm="4">
                            <h3 class="v-label v-label--active theme--light radioButtonRelatorioTce">
                                <label>
                                    Tipo <span class="ml-1 red--text">*</span>
                                </label>
                            </h3>
                            <v-radio-group
                                row
                                v-model="relatorio.tipo"
                                class="checkboxRelatorioTce"
                                v-validate="isRelatorioInventario? 'required' : ''"
                            >
                                <v-radio label="Analítico" value="ANALITICO"/>
                                <v-radio label="Sintético" value="SINTETICO"/>
                            </v-radio-group>
                        </v-col>

                        <v-col v-if="isRelatorioInventario" cols="12" md="4" sm="4" xs="12">
                            <campo-inteiro
                                required
                                class="campoAno"
                                :minnumber="2023"
                                name="anoReferencia"
                                label="Ano Referência"
                                v-model="relatorio.ano"
                                :maxnumber="9999"
                                placeholder="Digite o ano de Referência"
                                :mensagemObrigatoriedade="'O Ano deve ser igual ou maior do que'"
                            />
                        </v-col>

                        <v-col v-if="hasRelatorioSelecionado" cols="12" md="4" sm="4">
                            <v-autocomplete
                                item-value="id"
                                :items="orgaos"
                                item-text="descricao"
                                v-model="relatorio.orgao"
                                :placeholder="placeholderSelecaoOrgao"
                                :itensSelecionados="hasOrgaoSelecionado"
                                no-data-text="Não há orgãos com este nome"
                                @change="informarObrigatoriedadeCampos"
                                @keyup.enter="informarObrigatoriedadeCampos"
                            >
                                <template v-slot:label>
                                    Órgão
                                    <span class="ml-1 red--text">*</span>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
            <div class="actions-report-form">
                <botao-primario
                    class="ml-0"
                    esconder-icone
                    texto-botao="gerar pdf"
                    :desabilitado="!camposObrigatoriosPreenchidos"
                    texto-tooltip="Preencha os campos obrigatórios para gerar o PDF"
                    @click="gerarRelatorio('PDF')"
                />
                <botao-primario
                    class="ml-1"
                    esconder-icone
                    texto-botao="gerar xlsx"
                    :desabilitado="!camposObrigatoriosPreenchidos"
                    texto-tooltip="Preencha os campos obrigatórios para gerar o XLSX"
                    @click="gerarRelatorio('XLSX')"
                />
            </div>
        </az-container>
    </div>
</template>

<script>
    import BotaoPrimario from '@/views/components/botoes/BotaoPrimario.vue'
    import CampoInteiro from '@/views/components/campos/CampoInteiro.vue'
    import moment from 'moment-timezone'
    import {mapActions} from 'vuex'
    import {actionTypes} from '@/core/constants'

    export default {
        name: 'RelatoriosTCE',
        components: {
            CampoInteiro,
            BotaoPrimario,
        },

        data() {
            return {
                relatorio: {
                    ano: null,
                    tipo: null,
                    orgao: null,
                    dataFim: null,
                    formato: null,
                    dataInicio: null,
                    tipoRelatorio: null,
                },
                comboRelatorios: {
                    INVENTARIO_DOS_BENS_INTANGIVEIS: 'Inventário dos Bens Intangíveis',
                    RESUMO_INVENTARIO_MATERIAL_INTANGIVEL: 'Resumo do Inventário de Material Intangível',
                    DEMONSTRATIVO_ANALITICO_ENTRADAS_SAIDAS: 'Demonstrativo Analítico Entradas e Saídas',
                },
                orgaos: [],
                modalOrgao: false,
                moment,
            }
        },

        computed: {
            hasRelatorioSelecionado() {
                return Boolean(this.relatorio.tipoRelatorio)
            },
            isRelatorioInventario() {
                return this.relatorio.tipoRelatorio === 'INVENTARIO_DOS_BENS_INTANGIVEIS'
            },
            isRelatorioDemonstrativoOuResumo() {
                return this.relatorio.tipoRelatorio === 'RESUMO_INVENTARIO_MATERIAL_INTANGIVEL' ||
                    this.relatorio.tipoRelatorio === 'DEMONSTRATIVO_ANALITICO_ENTRADAS_SAIDAS'
            },
            camposObrigatoriosPreenchidos() {
                return this.hasRelatorioSelecionado &&
                    (!this.isRelatorioDemonstrativoOuResumo || (this.relatorio.dataInicio && this.relatorio.dataFim)) &&
                    (!this.isRelatorioInventario || (this.relatorio.tipo && this.relatorio.ano)) &&
                    this.hasOrgaoSelecionado
            },
            placeholderSelecaoOrgao() {
                if (this.relatorio.orgao) return this.relatorio.orgao.texto
                return 'Selecione o órgão'
            },
            hasOrgaoSelecionado() {
                return Boolean(this.relatorio.orgao)
            },
        },

        async mounted() {
            await this.buscarOrgaos()
        },

        watch: {
            'relatorio.tipoRelatorio': function (value) {
                if (value === 'INVENTARIO_DOS_BENS_INTANGIVEIS') {
                    this.relatorio.tipo = 'ANALITICO'
                }
            },
        },

        methods: {
            ...mapActions({
                gerarRelatoriosTce: actionTypes.RELATORIO.RELATORIOS_TCE.GERAR_RELATORIOS_TCE
            }),
            async gerarRelatorio(formato) {
                this.relatorio.formato = formato
                await this.gerarRelatoriosTce(this.relatorio)
            },
            async informarObrigatoriedadeCampos() {
                if (!this.informadoObrigatoriedadeCampos) {
                    await this.$validator._base.validateAll()
                    this.informadoObrigatoriedadeCampos = true
                }
            },
            async buscarOrgaos() {
                const resultado = await this.$store.dispatch(actionTypes.COMUM.BUSCAR_ORGAOS)
                this.orgaos = resultado.items
            },
            limparDataFim() {
                if (this.relatorio.dataInicio > this.relatorio.dataFim) {
                    this.relatorio.dataFim = null
                }
            },
        },
    }

</script>

<style scoped lang="stylus">
.campoDataInicio, .campoDataFim
    margin-top: 7px !important

::v-deep.relatorioTceContainer
    .actions-report-form
        padding 10px
        margin-top 0
        border-top solid thin rgba(0, 0, 0, .12)
        div
            display initial
            margin-left 10px
    .campoAno
        .texto-prefix-suffix
            font-size 13px
            color #888 !important
            margin-top 35px !important

    .campoEnumRelatoriosTce
        margin-top 11px

.formRelatoriosTce
    min-height 70vh

::v-deep .checkboxRelatorioTce
    i
        font-size 15px
        margin-left -5px

    .v-input--selection-controls__ripple
        top -6px
        width 23px
        left -11px
        margin 7px
        height 22px
        cursor pointer
        position absolute
        border-radius 50%
        transition inherit

.radioButtonRelatorioTce
    color #777 !important
    font-size 14px !important
    margin-bottom 10px

</style>



